import React, { useContext, useState } from "react";

import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";

import {
	EventContext,
	OfferOptionsContext,
	SportOfferContext,
} from "@gp/components";
import { useRootAppStore } from "@hooks";
import { FavoritesStoreContext } from "@state/context/favorites/FavoritesStoreContext";
import { THEME_SETTINGS } from "@theme-settings";
import classnames from "classnames";
import { observer } from "mobx-react";

export const EventFavoriteIcon = !THEME_SETTINGS.features.isFavoritesEnabled
	? () => null
	: observer(function EventFavoriteIcon() {
			const sportOfferContext = useContext(SportOfferContext);
			const rootStore = useRootAppStore();
			const event = useContext(EventContext);
			const favoriteStore = useContext(FavoritesStoreContext);
			const offerOptionsContext = useContext(OfferOptionsContext);

			const { t } = useTranslation();
			const [isHover, setIsHover] = useState(false);

			// @ts-expect-error
			if ((offerOptionsContext.isHistoryEvent?.(event.id) ?? false) || sportOfferContext.isOutright) {
				return null;
			}
			const tooltipId = `favorites-${event.id}`;

			const isFavorite = favoriteStore.isUserFavoriteEvent(event.id);

			function onButtonClick() {
				if (isFavorite) {
					favoriteStore.removeUserFavoriteEvent(event.id);
				} else {
					favoriteStore.addUserFavoriteEvent(event.id);
				}
			}
			const tooltipMessage = !rootStore.userAuthStore.isLoggedIn
				? t("FAVORITES.NONAUTH_TOOLTIP")
				: "";

			return (
				<>
					<div className="offer__body__data offer__favorites">
						<button
							data-tooltip-id={tooltipId}
							data-tooltip-content={tooltipMessage}
							data-tooltip-position-strategy="fixed"
							type="button"
							className="offer__favorites__btn btn btn--square btn--square--reset btn--ghost"
							onClick={onButtonClick}
							onMouseEnter={() => setIsHover(true)}
							onMouseLeave={() => setIsHover(false)}
							disabled={!rootStore.userAuthStore.isLoggedIn}
						>
							<i
								className={classnames(
									"offer__favorites__icon u-icon u-icon--sml",
									{
										"u-icon--favorite--bold u-color--sent--warning":
											isFavorite ||
											(!isFavorite && isHover),
										"u-icon--favorite--alt u-color--sent--muted":
											!isFavorite && !isHover,
									}
								)}
							/>
						</button>
					</div>

					<Tooltip
						id={tooltipId}
						className="at-tooltipTeams react-tooltip--primary"
						place="right-start"
						closeOnResize={true}
					/>
				</>
			);
		});
